import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';
import { colors, fontFamilies } from '../../../../../constants/theme';
import { SectionHeading as BaseSectionHeading } from '../../../../../ui/typography';

export const CreedSectionWrapper = styled(Box)(({ theme }) => ({}));

export const SectionHeading = styled(BaseSectionHeading)(({ theme }) => ({
  fontFamily: fontFamilies?.gotham,
  fontWeight: 400,
  fontSize: '50px',
  lineHeight: '58px',
  letterSpacing: '-1.2px',
  textAlign: 'left',
  margin: '0 auto 30px',
  [theme.breakpoints.down('lg')]: {
    textAlign: 'center',
  },
}));

export const SectionSubtext = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtext,
  textAlign: 'center',
  fontSize: '18px',
  lineHeight: '26px',
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
  [theme.breakpoints.up('lg')]: {
    textAlign: 'left',
    fontSize: '22px',
    lineHeight: '23px',
    minWidth: '550px',
  },
}));

export const CreedContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(4),
  alignItems: 'center',
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: '1fr 1fr',
    gap: '50px',
    maxWidth: '1100px',
    margin: '0 auto',
    width: '100%',
  },
}));

export const CreedLeftColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  order: 2,
  [theme.breakpoints.up('lg')]: {
    order: 1,
    justifyContent: 'center',
  },
}));

export const CreedImage = styled('img')(({ theme }) => ({
  display: 'block',
  minWidth: '550px',
  height: '750px',
  objectFit: 'cover',
  borderRadius: '30px',
  border: '10px solid',
  borderColor: colors.whiteText,
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)',
  [theme.breakpoints.down('md')]: {
    minWidth: 'auto',
    height: '500px',
  },
}));

export const CreedRightColumn = styled(Box)(({ theme }) => ({
  order: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  [theme.breakpoints.up('lg')]: {
    order: 2,
  },
}));

export const CreedPillsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
}));

export const CreedButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '24px',

  [theme.breakpoints.up('lg')]: {
    justifyContent: 'flex-start',
  },
}));
